import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { proposalMutationScopeId } from '@/api/mutations/proposals/proposalMutationScope';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  DeleteProposalLineItemMutation,
  ProposalLineItemIdInput,
} from '@/gql/graphql';

const DELETE_PROPOSAL_LINE_ITEM_MUTATION = graphql(`
  mutation DeleteProposalLineItem($input: ProposalLineItemIdInput!) {
    deleteProposalLineItem(input: $input)
  }
`);

const useDeleteProposalLineItem = (args?: {
  proposalId?: string;
  options?: UseMutationOptions<
    DeleteProposalLineItemMutation,
    unknown,
    ProposalLineItemIdInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: ProposalLineItemIdInput) => {
      return gqlClient.request(DELETE_PROPOSAL_LINE_ITEM_MUTATION, { input });
    },
    scope: args?.proposalId
      ? { id: proposalMutationScopeId(args.proposalId) }
      : undefined,
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useDeleteProposalLineItem;
